/* tslint:disable */
/* eslint-disable */
/**
 * external-information-requests
 * Medicaid Pending document requests to family members, with the staff workspace and the family portal
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PortalDocument } from './PortalDocument';
import {
    PortalDocumentFromJSON,
    PortalDocumentFromJSONTyped,
    PortalDocumentToJSON,
    PortalDocumentToJSONTyped,
} from './PortalDocument';
import type { PortalSession } from './PortalSession';
import {
    PortalSessionFromJSON,
    PortalSessionFromJSONTyped,
    PortalSessionToJSON,
    PortalSessionToJSONTyped,
} from './PortalSession';
import type { PortalRequest } from './PortalRequest';
import {
    PortalRequestFromJSON,
    PortalRequestFromJSONTyped,
    PortalRequestToJSON,
    PortalRequestToJSONTyped,
} from './PortalRequest';

/**
 * 
 * @export
 * @interface PortalPreview
 */
export interface PortalPreview {
    /**
     * 
     */
    session: PortalSession;
    /**
     * 
     */
    requests: Array<PortalRequest>;
    /**
     * 
     */
    documents: Array<PortalDocument>;
}

/**
 * Check if a given object implements the PortalPreview interface.
 */
export function instanceOfPortalPreview(value: object): value is PortalPreview {
    if (!('session' in value) || value['session'] === undefined) return false;
    if (!('requests' in value) || value['requests'] === undefined) return false;
    if (!('documents' in value) || value['documents'] === undefined) return false;
    return true;
}

export function PortalPreviewFromJSON(json: any): PortalPreview {
    return PortalPreviewFromJSONTyped(json, false);
}

export function PortalPreviewFromJSONTyped(json: any, ignoreDiscriminator: boolean): PortalPreview {
    if (json == null) {
        return json;
    }
    return {
        
        'session': PortalSessionFromJSON(json['session']),
        'requests': ((json['requests'] as Array<any>).map(PortalRequestFromJSON)),
        'documents': ((json['documents'] as Array<any>).map(PortalDocumentFromJSON)),
    };
}

export function PortalPreviewToJSON(json: any): PortalPreview {
    return PortalPreviewToJSONTyped(json, false);
}

export function PortalPreviewToJSONTyped(value?: PortalPreview | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'session': PortalSessionToJSON(value['session']),
        'requests': ((value['requests'] as Array<any>).map(PortalRequestToJSON)),
        'documents': ((value['documents'] as Array<any>).map(PortalDocumentToJSON)),
    };
}

